import * as React from "react";
import { useLocation, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getNewNotifications, getNotifications } from "../../app/modules/Notification/ducks/action";
import { dashboardAccessManager } from "../../utils/dashBoardAccess";
import { useGetOrganization } from "../../api/v1";
import { isReceiptsModuleEnabled } from "../../utils/isReceiptsModuleEnabled";
import { isAuthenticated } from "./auth";
import { isPublicRoute } from "./publicRoutes";

export function usePagesSetup(props: Record<string, unknown>) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch: any = useDispatch();

  const noticeId = searchParams.get("noticeId");

  React.useEffect(() => {
    if (!noticeId && !isAuthenticated() && !isPublicRoute(location.pathname)) {
      navigate("/login", { state: location });
    }
  }, [noticeId, location, navigate]);

  React.useEffect(() => {
    if (!isAuthenticated()) {
      return;
    }

    const intervalId = setInterval(async () => {
      await dispatch(getNotifications(1));
      await dispatch(getNewNotifications(1));
    }, 2 * 60000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  const userScreenAccess: any = useSelector((state: any) => state?.userScreens?.userScreenAccess);
  const { organization, isLoadingOrganization } = useGetOrganization();
  const receiptsEnabled = isReceiptsModuleEnabled(organization);
  const shouldRenderReceiptsRoute = isLoadingOrganization || receiptsEnabled;

  const withScreenAccess = (Component: React.ComponentType<any>, allowedScreen: string, type = false) => {
    if (userScreenAccess?.length != 0 && !userScreenAccess.includes(allowedScreen) && !type) {
      return <Navigate to="/unauthorized" />;
    }

    if (!dashboardAccessManager(allowedScreen) && type) {
      return <Navigate to="/unauthorized" />;
    }
    return <Component {...props} />;
  };

  return {
    withScreenAccess,
    shouldRenderReceiptsRoute,
    navigate,
    isUserAuthenticated: isAuthenticated(),
  };
}
